/** @format */

import styled from 'styled-components';

export const ButtonWrapper = styled.div`
	${(props) => props.border && `border: ${props.border}`};
	background: ${(props) => props.background};
	color: ${(props) => props.color};
	padding: ${(props) => props.size};
	white-space: nowrap;
	border-radius: 12.5px;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 600;
	font-size: ${(props) => props.fontSize}px;
	line-height: 17px;
	cursor: pointer;

	${(props) =>
		props.hover &&
		`&:hover {
		background: ${props.hover};
	}`}

	&:active {
		transform: scale(0.95, 0.95);
		${(props) => props.active && `background: ${props.active};`}
	}
`;

export const SpinWrapper = styled.div`
	width: 17px;
	height: 17px;
`;

export const ImgWrapper = styled.div`
	margin-right: 10px;
`;
